module.exports = __webpack_public_path__ + "static/logo-big-3d9d09dc5d1eb1d607cddac874630a14.png";